export const environment = {
  production: true,

  /////////////////sit///////////

    getDeviceName: "https://secureid.jiolabs.com/portalbackend/getDeviceName?phonenr=",
    getPersonData: "https://secureid.jiolabs.com/portalbackend/getPersonData",
    disableAccount: "https://secureid.jiolabs.com/portalbackend/disableAccount",
      sendFeedback: "https://secureid.jiolabs.com/portalbackend/sendFeedback",
    captcha: "https://secureid.jiolabs.com/portalbackend/getCaptcha",
    validate:"https://secureid.jiolabs.com/smartid/ValidatePhoneNo/validate",
    // //sendSms :"https://secureid.jiolabs.com/smartid/ValidatePhoneNo/sendSMS",
    sendSms : " https://secureid.jiolabs.com/secureid/portalbackend/sendSMS?phoneNumber=",
    loginUrl: "https://secureid.jiolabs.com/smartid/myTransactions/#/homepage/",
    getData_url: "https://secureid.jiolabs.com/portalbackend/getTransactions?",
    authenticate_url: "https://secureid.jiolabs.com/portalbackend/authenticate/",
    authenticate_Qr:"https://secureid.jiolabs.com/portalbackend/authenticate-qr",
    Kycdisplay:"https://secureid.jiolabs.com/portalbackend/displaydata",

   
   validate_url: "https://secureid.jiolabs.com/portalbackend/validate",
   iOSlink:"http://tiny.cc/JioID",
   androidlink:"https://appurl.io/FvS-VDiqA",
    ess:"https://fioriqa.ril.com/sap/bc/ui5_ui5/sap/zhr_jioess_lp/index.html?sap-client=386&sap-ui-language=EN&sap-ui-appcache=false&saml2idp=https://sitohs.jio.com:4443/oam/fed",
    intunePlayStore: "https://play.google.com/store/apps/details?id=com.microsoft.windowsintune.companyportal&hl=en_IN&gl=US",
    intuneAppStore: "https://apps.apple.com/us/app/intune-company-portal/id719171358",
    intellPlayStore: "https://play.google.com/store/apps/details?id=com.airwatch.androidagent&hl=en_IN&gl=US",
    intellAppStore: "https://apps.apple.com/in/app/intelligent-hub/id338761996",
    citrix:"http://10.162.6.107:8080/authenticationForCitrix/#/selectOption",
    // sitappversion : "1.1.4",
    sitappversion : "1.2.0",



  /////////////////////////////////////////production//////////////////
  // getDeviceName: "https://secureid.jio.com/portalbackend/getDeviceName?phonenr=",
  // getPersonData: "https://secureid.jio.com/portalbackend/getPersonData",
  // disableAccount: "https://secureid.jio.com/portalbackend/disableAccount",
  // sendFeedback: "https://secureid.jio.com/portalbackend/sendFeedback",
  // captcha: "https://secureid.jio.com/portalbackend/getCaptcha",
  // validate: "https://secureid.jio.com/smartid/ValidatePhoneNo/validate",
  // getData_url: "https://secureid.jio.com/portalbackend/getTransactions?",
  // authenticate_url: "https://secureid.jio.com/portalbackend/authenticate/",
  // authenticate_Qr: "https://secureid.jio.com/portalbackend/authenticate-qr",
  
  // validate_url: "https://secureid.jio.com/portalbackend/validate",
  // iOSlink: "https://testflight.apple.com/join/kxPAtBT9",
  // // //sendSms: "https://secureid.jio.com/smartid/ValidatePhoneNo/sendSMS",
  // sendSms : " https://secureid.jio.com/secureid/portalbackend/sendSMS?phoneNumber=",
  // ess: "https://ess.jio.com",
  // androidlink: "https://appurl.io/VbT9xpN-M",
  // intunePlayStore: "https://play.google.com/store/apps/details?id=com.microsoft.windowsintune.companyportal&hl=en_IN&gl=US",
  // intuneAppStore: "https://apps.apple.com/us/app/intune-company-portal/id719171358",
  // intellPlayStore: "https://play.google.com/store/apps/details?id=com.airwatch.androidagent&hl=en_IN&gl=US",
  // intellAppStore: "https://apps.apple.com/in/app/intelligent-hub/id338761996",
  // citrix:"https://secureid.jio.com/citrixlogin ",

  // // prodappversion: "1.1.4",
  // prodappversion: "1.2.0",
};